import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-cancel',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './payment-cancel.component.html',
  styleUrl: './payment-cancel.component.scss',
})
export class PaymentCancelComponent {
  constructor(private router: Router) {}

  ngOnInit() {
    setTimeout(() => {
      this.redirect();
    }, 5000);
  }

  redirect() {
    this.router.navigate(['']);
  }
}
